<style>
@import '../custom/css/professionalguide.css';
</style>

<template>
  <section class="guia-profissionais">
    <router-view />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'guia-profissionais',
  cumputed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
  },
  methods: {},
};
</script>
